/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ICheckoutGooglePayViewProps } from './ext-checkout-google-pay';

const CheckoutGooglePayView: React.FC<ICheckoutGooglePayViewProps> = props => {
    const { alert, checkoutGooglePay, checkoutButton } = props;
    return (
        <Module {...checkoutGooglePay}>
            {alert}
            <div ref={ref => ref?.appendChild(checkoutButton || document.createElement('div'))}></div>
        </Module>
    );
};

export default CheckoutGooglePayView;
